import { Navigate, Outlet } from 'react-router-dom';
import { Box } from '@radix-ui/themes';
import { observer } from 'mobx-react-lite';

import { useRootStore } from 'core/hooks/use-root-store';
import { ReactNode } from 'react';
import NavBar from 'Components/element/NavBar';
import Footer from 'Components/element/Footer';
import { GlobalLoader } from 'shared/components/global-loader';

const ProtectedRouteView = () => {
   const rootStore = useRootStore();

   function render(): ReactNode {
      if (rootStore.userStore.isInit) {
         return (
            <Box width="100%" height="100vh">
               <GlobalLoader loaderStore={rootStore.globalLoader} />
            </Box>
         );
         
      }

      if (!rootStore.userStore.user) {
         return <Navigate to="/" replace />;
      }

      if (rootStore.userStore.user && rootStore.userStore.user.user_type !== 'recruiter') {
         return <Navigate to="/auth/employer-login" replace />;
      }

      return <Outlet />;
   }

   return (
      <>
         <NavBar />
         {render()}
         <Footer />
      </>
   );
};

export const ProtectedEmployerRoute = observer(ProtectedRouteView);
